import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useContext,
} from "react";
import { getProductsList } from "./ERPActions/erpActions";
import { useDispatch, useSelector } from "react-redux";
import { TextField } from "@mui/material";
import debounce from "lodash.debounce";
import { DataContext } from "./ERPBilling";
import { helperServices } from "../../shared/helper";

export default function ERPProductSearch(props) {
  const dispatch = useDispatch();
  // const {locationId, setLocationId } = useContext(DataContext);
  const productsList = useSelector((state) => state.erpProductsList); // adjust path as per your store
  const [patientId, setPatientId] = useState(props.patientId);
  const [visitId, setVisitId] = useState(props.visitId);
  const [patientInfo, setPatientInfo] = useState();
  // const [locationId, setLocationId] = useState(0);
  const [search, setSearch] = useState("");
  const [filteredProduct, setFilteredProduct] = useState([]);
  const [productsData, setProductsData] = useState([]);
  const [hideResults, setHideResults] = useState(false);
  const [selectedLocationDetails, setSelectedLocationDetails] = useState(
    props.selectedLocationDetails,
  );

  const [selectedIndex, setSelectedIndex] = useState(-1);
  const itemRefs = useRef([]);

  useEffect(() => {
    console.log("props data: ", props);

    let patId = props.patientId;
    let vistid = props.visitId;
    let locDetails = props.selectedLocationDetails;
    console.log("useeffect: ", patId, vistid, locDetails);
    // console.log("locationDetails: ", locationDetails);

    setPatientId(patId);
    setVisitId(vistid);
    // setLocationDetails(locDetails);  
    console.log("call fetchProduct in useeffect ");
    // fetchProduct('', patId, vistid);
    // dispatch(getProductsList('', patId, vistid, locationId));
    console.log("call fetchProduct in useeffect completed");
  }, [props.selectedLocationDetails]);

  const fetchProduct = async (prodSearch, patId, vistid, locationDetail) => {
    try {
      // update code to consider all the locationids of the selected location
      let locationId = [
        ...new Set(
          locationDetail.map(
            (element) =>
              element?.locationDetails?.erpLocationDetails?.[0].locationid,
          ),
        ),
      ];
      let serviceTypesAllowed = [
        ...new Set(
          locationDetail?.flatMap((element) => element?.servicesAllowed || []),
        ),
      ];
      const accessLevelServicesAllowed =
        helperServices.getServicesAllowed?.() || [];

      console.groupCollapsed(
        `[ERPProductSearch] Diagnose search: "${prodSearch}"`,
      );
      console.log("Patient/visit:", { patientId: patId, visitId: vistid });
      console.log("Selected location details:", locationDetail);
      console.log("ERP location IDs sent to API:", locationId);
      console.log(
        "Location servicesAllowed used by current UI filter:",
        serviceTypesAllowed,
      );
      console.log(
        "Access-level servicesAllowed from login/localStorage:",
        accessLevelServicesAllowed,
      );

      // let locationId = locationDetail.map((element)=>element?.locationDetails?.erpLocationDetails?.[0].locationid);
      // dispatch(getProductsList(prodSearch, patId, vistid, locationId));
      const onlyBillable = true;
      const searchProds = await dispatch(
        getProductsList(prodSearch, patId, vistid, locationId, onlyBillable),
      );
      console.log("search product response : ", searchProds);
      console.log("Products returned by API:", {
        count: Array.isArray(searchProds) ? searchProds.length : 0,
        products: searchProds,
      });
      if (searchProds && hideResults === false) {
        console.log("search product : response2 : ", searchProds); // searchProds.erpResp);
        if (searchProds && Array.isArray(searchProds)) {
          console.log("search prod: props: ", props);
          console.log("search prod: locationDetails: ", locationDetail);
          let allowedProducts = [];
          if (locationDetail) {
            allowedProducts = searchProds.filter(
              (prod) =>
                serviceTypesAllowed.includes(prod?.categoryName) ||
                prod.typePackage,
            );
          }

          const rejectedByLocationServiceFilter = searchProds.filter(
            (prod) =>
              !serviceTypesAllowed.includes(prod?.categoryName) &&
              !prod.typePackage,
          );
          console.log("Category/location filter result:", {
            allowedCount: allowedProducts.length,
            rejectedCount: rejectedByLocationServiceFilter.length,
            rejected: rejectedByLocationServiceFilter.map((prod) => ({
              productId: prod.productId,
              name: prod.name,
              categoryName: prod.categoryName,
              typePackage: prod.typePackage,
              reason: `category "${prod.categoryName}" is not in location servicesAllowed`,
            })),
          });

          console.log("allowedProducts : searchProds: ", allowedProducts);
          // let prodListByLocation = searchProds.filter((prod)=>{return prod});
          //search on first charecter
          const searchTerm = prodSearch.toLowerCase();
          const filtered = allowedProducts.filter(
            (product) =>
              product.name && product.name.toLowerCase().startsWith(searchTerm),
          );
          const rejectedByNameFilter = allowedProducts.filter(
            (product) =>
              !product.name ||
              !product.name.toLowerCase().startsWith(searchTerm),
          );
          console.log("Name-prefix filter result:", {
            searchTerm,
            displayedCount: filtered.length,
            displayed: filtered.map((prod) => prod.name),
            rejected: rejectedByNameFilter.map((prod) => prod.name),
          });
          if (searchProds.length > 0 && filtered.length === 0) {
            console.warn(
              "[ERPProductSearch] API returned products, but frontend filters removed all of them.",
            );
          }
          console.groupEnd();
          setProductsData([...filtered]);
          setFilteredProduct([...filtered]);
        } else {
          console.warn("Expected the product response to be an array.", searchProds);
          console.groupEnd();
          setProductsData([]); // fallback to empty array
          setFilteredProduct([]);
          console.log("searchProds is empty or not a array : ", prodSearch);
          console.warn("No packageServiceList found in response:", searchProds);
        }
      } else {
        console.warn("Results hidden or API returned no product data:", {
          hideResults,
          searchProds,
        });
        console.groupEnd();
        console.warn("No products found in response");
        setProductsData([]);
        setFilteredProduct([]);
      }
    } catch (error) {
      console.groupEnd();
      console.error("Error fetching Invoices :", error);
      // You might want to add error handling here, such as setting an error state
      setProductsData([]);
      setFilteredProduct([]);
    }
  };

  const searchProduct = (event) => {
    setHideResults(false);
    let searchValue = event.target.value;
    setSearch(searchValue);

    if (searchValue.length > 1) {
      debounceSearchProducts(searchValue);
    } else if (searchValue.length < 1) {
      setHideResults(true);
      setFilteredProduct([]);
      setProductsData([]);
    }
  };

  const debounceSearchProducts = useCallback(
    debounce((value) => {
      fetchProduct(
        value,
        props.patientId,
        props.visitId,
        props.selectedLocationDetails,
      );
    }, 500),
    [props.selectedLocationDetails],
  );

  const handleOnClick = (product, index) => {
    console.log("productSelected: ", product, index);
    setSearch("");
    setFilteredProduct([]);
    setSelectedIndex(-1);
    props.productSelected(product);
  };

  // ⌨️ Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (hideResults || filteredProduct.length === 0) return;

      if (event.key === "ArrowDown") {
        setSelectedIndex((prev) =>
          prev < filteredProduct.length - 1 ? prev + 1 : 0,
        );
      } else if (event.key === "ArrowUp") {
        setSelectedIndex((prev) =>
          prev > 0 ? prev - 1 : filteredProduct.length - 1,
        );
      } else if (event.key === "Enter") {
        if (selectedIndex >= 0 && selectedIndex < filteredProduct.length) {
          handleOnClick(filteredProduct[selectedIndex], selectedIndex);
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [filteredProduct, selectedIndex, hideResults]);

  // 🔁 Scroll to selected item
  useEffect(() => {
    if (selectedIndex >= 0 && itemRefs.current[selectedIndex]) {
      itemRefs.current[selectedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedIndex]);

  return (
    <>
      {/* <Autocomplete
        id="Search-Product"
        // searchProduct
        options={productsData.map((prod) => prod.name)}
        renderInput={(params) => <TextField {...params} label="SearchProduct" />}
      /> */}
      {/* <div className="d-flex justify-content-center align-items-center"> */}
      <div className="d-flex flex-column">
        <div className="align-items-center">
          {/* <input class="erpProdSearchInput" value={search} onChange={searchProduct} placeholder="Search Product" /> */}
          <TextField
            data-global-search
            id="global-search"
            className="erpProdSearchInput"
            placeholder="Search Products by name ....."
            autoFocus
            value={search}
            type="search"
            onChange={searchProduct}
            inputRef={props.searchInputRef}
            InputProps={{
              style: {
                paddingLeft: "2px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }, // Adjust padding as needed
            }}
          />
        </div>
        <div
          className={
            filteredProduct.length > 0 ? "erpSearchProd show" : "erpSearchProd"
          }
          // style={{ maxWidth: "390px" }}
        >
          <div
            className="mt-2 shadow service-list-container searchedProductDiv"
            style={{
              maxHeight: "200px",
              overflowY: "auto",
              position: "absolute",
              zIndex: 1000,
              backgroundColor: "#fff",
            }}
          >
            {filteredProduct &&
              filteredProduct.length > 0 &&
              hideResults === false &&
              filteredProduct.map((service, index) => (
                <div
                  key={index}
                  ref={(el) => (itemRefs.current[index] = el)}
                  className={`border-bottom blog-comments__item d-flex p-2 cpointer flex-wrap border-0 flex-column erpSearchProdElementInnerShadow ${
                    index === selectedIndex ? "selected-item" : ""
                  }`}
                  onClick={() => handleOnClick(service, index)}
                >
                  <h6 className="mb-0">
                    {service.name}

                    <span
                      style={{ fontSize: 15, float: "right", color: " #333" }}
                    >
                      {" Rs. " + service.priceDiscountIncTax.toFixed(2)}
                    </span>
                  </h6>
                </div>
              ))}
          </div>
        </div>
      </div>
      {/* <TextInput
        inlineImageLeft='search_icon'
        // style={styles.input}
        onChangeText={setSearch}
        value={search}
        placeholder="Search Product"
        // keyboardType="numeric"
      /> */}
    </>
  );
}
